import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { constants } from '../../config/app.constants';
import { get, forEach } from 'lodash-es';

const {
  recoverPassword,
  userLogin
} = constants.config;


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  token = {api_token: `${localStorage.getItem('token')}` }  ;

  constructor(private http: HttpClient) {
   }

  login(data){
    console.log(environment.api + '/users/login', data);
    return this.http.post(environment.api + '/users/login', data);
  }
  register(data){
    return this.http.post(environment.api + '/users', data);
  }
  user(){
    return this.http.post(environment.api + '/userauth', this.token);
  }
  updateInfo(data){
    return this.http.put(environment.api + '/info', data);
  }
  updatePassword(data){
    return this.http.put(environment.api + '/password', data);
  }
}
